/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Live_Caption_Youtube_Region_6Inputs */



/**
* | output |
* | --- |
* | "Center right" |
*
* @param {Live_Caption_Youtube_Region_6Inputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const live_caption_youtube_region_6 = /** @type {((inputs?: Live_Caption_Youtube_Region_6Inputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Caption_Youtube_Region_6Inputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Centre droit")
	if (locale === "de") return /** @type {LocalizedString} */ ("Mitte rechts")
	if (locale === "it") return /** @type {LocalizedString} */ ("Chiamata al centro")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Центр справа")
	if (locale === "es") return /** @type {LocalizedString} */ ("Centro derecha")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("中右")
	if (locale === "ja") return /** @type {LocalizedString} */ ("中央右")
	if (locale === "hi") return /** @type {LocalizedString} */ ("केंद्र दाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Centro-direita")
	return /** @type {LocalizedString} */ ("Center right")
});